import {
  FaLock,
  FaCertificate,
  FaCubes,
  FaKey,
} from "@onemind-services-llc/react-icons-ng/fa";
import HeroBg from "public/marketplace-apps/hero/Hero-section-certmanager.png";

export const CERT_MANAGER_CONSTANTS = {
  HERO: {
    title: "OneMind Services — cert-manager (One-Click Application)",
    desc: "Automate TLS certificate management for your Kubernetes workloads with ease using Cert Manager.",
    button: {
      label: "Deploy Now",
      link: "contact-us",
    },
    image: HeroBg,
  },
  INTRO: {
    title: "General Information",
    text: "Cert-manager is a powerful and extensible X.509 certificate controller for Kubernetes and OpenShift workloads. It automates the issuance, renewal, and management of TLS certificates from various issuers, including Let's Encrypt, HashiCorp Vault, and private PKIs",
  },
  WHY_ONEMIND: {
    title: "Deploy Effortlessly with OneMind Ease ",
    desc: [
      {
        highlight: "One-Click Installation",
        text: " One-Click Installation : Launch a fully configured and secure cert-manager instance in minutes—no need to install or manage dependencies.",
      },
      {
        highlight: "Global Reach",
        text: " Global Reach : Deploy in any of our multiple data-center regions to keep latency low and performance high.",
      },
      {
        highlight: "Pre‑Configured Setup",
        text: " Pre‑Configured Setup : Includes cert-manager components, default configurations, and optimized system settings.",
      },
    ],
    marginTop: 0,
    btnText: "Start Now",
  },
  GET_STARTED: {
    title: "Access & Administration ",
    desc: [
      {
        text: "Once deployed, cert-manager operates within your Kubernetes cluster",
      },
    ],
    installation: {
      heading: "Installation Location -",
      text: "cert-manager is deployed in the Kubernetes cluster under the namespace ",
      location: "cert-manager",
    },
    ports: {
      heading: "Ports Used ",
      text: "Application, besides standard Kubernetes Ports, uses: ",
      list: ["9402 (metrics) "],
    },
    note: "Note: cert-manager integrates with Kubernetes API server and does not expose a standalone configuration file. ",
  },
  FEATURES: {
    items: [
      {
        icon: FaLock,
        title: "Automated Certificate Management",
        text: "Automatically issues and renews TLS certificates for Kubernetes workloads, ensuring secure communication.",
      },
      {
        icon: FaCertificate,
        title: "Support for Multiple Issuers",
        text: "Integrates with various certificate authorities, including Let's Encrypt, HashiCorp Vault, Venafi, and private PKIs.",
      },
      {
        icon: FaCubes,
        title: "Kubernetes Native",
        text: "Defines certificates and issuers as Kubernetes resources, enabling declarative management and integration with Kubernetes tools.",
      },
      {
        icon: FaKey,
        title: "Secure Storage",
        text: "Stores certificates and keys securely in Kubernetes Secrets, ensuring confidentiality and integrity.",
      },
    ],
  },
  BENEFITS: {
    title: "Resilience & Scaling ",
    options: [
      {
        label: "Backups & Snapshots",
        text: "Use OneMind’s snapshot feature or integrate standard backup procedures for Kubernetes resources.",
      },
      {
        label: "Security Out of the Box",
        text: "Hardened with RBAC configurations and secure communication channels.",
      },
      {
        label: "Scalable Architecture",
        text: "Scales with your Kubernetes cluster, supporting high-availability deployments.",
      },
    ],
  },
  SUPPORT: {
    docsText: "Cert-Manager Official Docs ",
    docsLink: "https://cert-manager.io/docs/",
  },
};
